export default __webpack_public_path__ + "static/media/menu-checkmark-on.1531625b.svg";